import { vnAppZoneContent }         from "./components/vn_app_zone_content";
import { vnAppZoneHeader }          from "./components/vn_app_zone_header";
import { vnAppZoneSubHeader } from "./components/vn_app_zone_subHeader";
import { vnAppZoneMenu }            from "./components/vn_app_zone_menu";
import { vnApp_sentinelbi }        from "./components/vnApp_sentinelbi";

window.onload = function(){

    let appInterface = null;

    const script = document.getElementById("main-script") as HTMLScriptElement;
    if (script) {

        const json = script.dataset.appInterface;
        if (json) {

            const appInterfaceParams = JSON.parse(json);
            appInterface = appInterfaceParams.interface;
        }
    }

    let vnAppZoneHeaderObj = new vnAppZoneHeader(document.getElementById('header'), appInterface);
    let vnAppZoneSubHeaderObj = new vnAppZoneSubHeader(document.getElementById('sub-header'), appInterface);
    let vnAppZoneMenuObj = new vnAppZoneMenu(document.getElementById('menu'), appInterface);
    let vnAppZoneContentObj = new vnAppZoneContent(document.getElementById('content'), appInterface);

    let vnAppObj = new vnApp_sentinelbi([vnAppZoneHeaderObj, vnAppZoneSubHeaderObj, vnAppZoneMenuObj, vnAppZoneContentObj], appInterface);

    //set reference to the main app from zones
    vnAppZoneHeaderObj.app = vnAppObj;
    vnAppZoneSubHeaderObj.app = vnAppObj;
    vnAppZoneMenuObj.app = vnAppObj;
    vnAppZoneContentObj.app = vnAppObj;
}



// WEBPACK FOOTER //
// ./js/app.ts